import * as React from "react";
import { Form, useFormApi } from "informedv4";
import { Tooltip } from "react-tooltip";
import { Required } from "../../../../forms/validation/Required";
import { TextArea } from "../../../../forms/informedv4/TextAreaV4";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface MiscCorrectionFormModal {
    originalEntry: string;
    newEntry: string;
}

export interface MiscCorrectionFormProps {
    onNext: (form: MiscCorrectionFormModal) => void;
    originalEntry: string;
    newEntry: string;
}

export const MiscCorrectionForm = ({ onNext, originalEntry, newEntry }: MiscCorrectionFormProps) => {
    const formApi = useFormApi();

    const onSubmit = () => {
        formApi.validate();

        const formState = formApi.getFormState();
        onNext(formState.values as unknown as MiscCorrectionFormModal);
    }

    return (
        <Form validateOn="submit" initialValues={{ originalEntry: originalEntry, newEntry: newEntry }} onSubmit={(formState) => onNext(formState.values as unknown as MiscCorrectionFormModal)}>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Request your data correction below giving as much detail as possible to
                            make it clear what is required to perform the correction
                        </p>
                        <div className="form-group col-md-6">
                            <label htmlFor="originalEntry">Original Entry</label>&nbsp;
                            <Tooltip id="originalEntryTooltip" style={{ zIndex: 2500 }}>
                                Enter data exactly how it appears in the system
                            </Tooltip>
                            <FontAwesomeIcon icon={faCircleInfo} className="text-muted" aria-hidden="true" data-tooltip-id="originalEntryTooltip" /> 
                            <TextArea
                                name="originalEntry"
                                id="originalEntry"
                                field="originalEntry"
                                className="form-control"
                                validate={Required}
                                validateOnBlur
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="newEntry">Entry to be changed to</label>
                            &nbsp;
                            <Tooltip id="newEntryTooltip" style={{ zIndex: 2500 }}>
                                Enter data as it should appear once the correction has been applied
                            </Tooltip>
                            <FontAwesomeIcon icon={faCircleInfo} className="text-muted" aria-hidden="true" data-tooltip-id="newEntryTooltip" />
                            <TextArea
                                name="newEntry"
                                id="newEntry"
                                field="newEntry"
                                className="form-control"
                                validate={Required}
                                validateOnBlur
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="submit">
                    Next
                </button>
            </div>
        </Form>
    );
};
